export type DevMenuProps = {
  viteBranch?: string;
};

export const DevMenu = ({ viteBranch }: DevMenuProps) => {
  if (!viteBranch) {
    return null;
  }

  return (
    <div
      style={{
        color: 'white',
        position: 'fixed',
        zIndex: 10000,
        backgroundColor: 'red',
        borderRadius: '5px',
        padding: '5px',
        bottom: 0,
        left: 0,
        fontFamily: 'monospace',
        fontSize: '12px'
      }}
    >
      Using branch: {atob(viteBranch)}
    </div>
  );
};
